import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  currentPage: 1,
  currentPageSize: 10,
  sortBy: "",
  sortOrder: "desc",
  search: "",
  status: "",

  clearSelection: false,
  selectedId: "",

  showDetailsModal: false,
  showCancelModal: false,
  showCreditModal: false,
  showSettingModal: false,

  /** The row the action was opened from, so the modals can show who they are acting on. */
  selectedSubscription: {},
};

const customerSubscriptionSlice = createSlice({
  name: "customerSubscription",
  initialState,
  reducers: {
    updateConfig: (state, action) => {
      action.payload(state);
    },
  },
});

export const { updateConfig } = customerSubscriptionSlice.actions;
export default customerSubscriptionSlice.reducer;
